import React, { Component } from 'react';

import FormField from '../form-field/FormField';
import './style.css';


export default class Job extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <div className={classes}>
        <div className='form__tips'>
          Учитесь и работаете одновременно? Напишите место вашей работы.
        </div>
        <div className='form__inputs'>
          <FormField
            title='Место работы' type='text'
            fieldName='company'
            errorHandler={this.props.jobHandler}
            clearFields={this.props.clearFields}
            defaultValue={this.props.defaultCompanyName}
          />
          <FormField
            title='Должность' type='text'
            fieldName='jobPosition'
            defaultValue={this.props.defaultJobPosition}
            errorHandler={this.props.positionHandler}
            clearFields={this.props.clearFields}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/form-blocks/Job.js